import React, { useContext } from 'react'

import { Button } from '@clientbase/clientbase-library'
import { Tooltip, useMediaQuery } from '@mui/material'

import { NegativationContext } from '../../../context'

const CancelNegativation: React.FC = () => {
  const { updateDialogCancel, negativation, updateModalDetail } =
    useContext(NegativationContext)

  const isMobile = useMediaQuery('(max-width:600px)')

  const handleOpen = () => {
    updateModalDetail((prevState) => ({ ...prevState, open: false }))
    // O uuid mantém a empresa da negativação ativa depois que o detalhe fecha
    // (SC-10999: sem ele, na visão do grupo o cancelamento ia na principal)
    updateDialogCancel({ open: true, uuid: negativation?.uuid })
  }

  const isAnalysing = negativation?.status === 'analysing'
  const isNegativated = negativation?.status === 'negativated'

  // Cancelar só se aplica antes de a negativação ser efetivada (analysing).
  // Quando já efetivada (negativated) exibimos o botão cinza e não clicável,
  // orientando a usar "Marcar como recuperado". Nos demais status o cancelar
  // não faz sentido e fica oculto.
  if (!isAnalysing && !isNegativated) return null

  const button = (
    <Button
      variantButton="neutral"
      onClick={handleOpen}
      disabled={isNegativated}
      fullWidth={isMobile}
    >
      Cancelar negativação
    </Button>
  )

  if (isNegativated)
    return (
      <Tooltip title='Negativação ativa. Para retirá-la, clique em "Marcar como recuperado".'>
        <span style={{ width: isMobile ? '100%' : 'auto' }}>{button}</span>
      </Tooltip>
    )

  return button
}

export default CancelNegativation
